import React from 'react';

const RUTA_COLECCION = '/recubrimientos-muros'; // confirmar slug de la página de colección

// Mismo orden, nombres, imágenes y enlaces de CatalogoMuros.js (solo los productos activos)
const muros = [
  {
    img: '/assets/img/productos/follaje-artificial/follaje-artificial-intro-der.jpg',
    alt: 'Follaje Artificial',
    nombre: 'Follaje Artificial',
    tipo: 'Interior y exterior',
    link: '/follaje-artificial',
  },
  {
    img: '/assets/img/recubrimientos-muros/recubrimientos-muros-catalogo-lambrin-convaco.jpg',
    alt: 'Muro Lambrín Cóncavo',
    nombre: 'Lambrín Cóncavo',
    tipo: 'Para Interiores',
    link: '/muro-lambrin-concavo',
  },
  {
    img: '/assets/img/recubrimientos-muros/recubrimientos-muros-catalogo-tipo-marmol-pvc.jpg',
    alt: 'Placa Tipo Mármol de PVC',
    nombre: 'Tipo Mármol de PVC',
    tipo: 'Para Interiores',
    link: '/muro-placa-tipo-marmol-page',
  },
  {
    img: '/assets/img/recubrimientos-muros/recubrimientos-muros-catalogo-lambrin-wpc.jpg',
    alt: 'Muro Lambrín WPC',
    nombre: 'Lambrín WPC',
    tipo: 'Interior y exterior',
    link: '/muro-lambrin-sintetico-page',
  },
  {
    img: '/assets/img/recubrimientos-muros/recubrimientos-muros-catalogo-vigueta-wpc.jpg',
    alt: 'Muro Vigueta WPC',
    nombre: 'Vigueta WPC',
    tipo: 'Interior y exterior',
    link: '/vigueta-wpc-page',
  },
  {
    img: '/assets/img/recubrimientos-muros/recubrimientos-muros-catalogo-bambu-espejo.jpg',
    alt: 'Muro Bambú Espejo',
    nombre: 'Bambú Espejo',
    tipo: 'Para Interiores',
    link: '/muro-bamboo-espejo',
  },
];

const CatalogoMurosHome = () => {
  return (
    <section id="muros" className="dt-muros dt-section">
      <div className="container">
        <div className="dt-muros__wrap">
          <div className="dt-muros__intro wow fadeIn" data-wow-delay="200ms">
            <span className="dt-eyebrow dt-eyebrow--light">Muros y techos</span>
            <h2 className="h1 mb-0">Conoce nuestra colección de recubrimiento para muros</h2>
            <p>
              Lambrines, placas tipo mármol, vigueta WPC y follaje artificial para interiores y exteriores.
            </p>
            <a className="dt-link dt-link--light" href={RUTA_COLECCION}>
              Ver todos los muros <i className="fas fa-arrow-right" aria-hidden="true"></i>
            </a>
          </div>

          <div className="dt-muros__grid">
            {muros.map((m, i) => (
              <a
                key={m.link}
                href={m.link}
                className="dt-muro wow fadeInUp"
                data-wow-delay={`${(i % 2) * 150}ms`}
              >
                <div className="dt-muro__img">
                  <img src={m.img} alt={m.alt} loading="lazy" />
                </div>
                <div className="dt-muro__body">
                  <div>
                    <span className="dt-muro__name">{m.nombre}</span>
                    <span className="dt-muro__tipo">{m.tipo}</span>
                  </div>
                  <span className="dt-muro__arrow"><i className="fas fa-arrow-right" aria-hidden="true"></i></span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CatalogoMurosHome;